/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../../../static/scss/resources/default.variables.scss';
@import '../../../../../static/scss/resources/default.style.scss';

.bg-model-duplicate {
  @extend .bg-warning-light;
}

.icon-server-connecting {
  background-image: $loader-icon-small !important;
  background-repeat: no-repeat;
  background-size: 18px !important;
  align-content: center;
  vertical-align: middle;
  height: 1.3em;
}
